import script from "./CatholicMedicalPartnersCase.vue?vue&type=script&setup=true&lang=js"
export * from "./CatholicMedicalPartnersCase.vue?vue&type=script&setup=true&lang=js"

import "./CatholicMedicalPartnersCase.vue?vue&type=style&index=0&id=68ba85de&lang=scss&scoped=true"
import "./CatholicMedicalPartnersCase.vue?vue&type=style&index=1&id=68ba85de&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ba85de"]])

export default __exports__